<template>
  <span class="brand-lockup" role="img" aria-label="Seeft" v-html="logoMarkup"></span>
</template>

<script setup lang="ts">
import logoMarkup from "../../../../assets/logo/logo-full-themeable.svg?raw";
</script>
